module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form js-match-start-playing-form">\n	<h1>COMPLETE REGISTRATION</h1>\n	<p>Great welcome back '+
((__t=( firstname ))==null?'':_.escape(__t))+
'!</p>\n	<p>We have now linked your Fantasy history with your NRL Account using your email <strong>'+
((__t=( email ))==null?'':_.escape(__t))+
'</strong>. To start picking your team, complete the registration process below.</p>\n\n	<div class="form-group">\n		<input type="text" id="team_name" name="team_name" class="js-team-name" placeholder="Create a Team Name" value="'+
((__t=( team_name ))==null?'':_.escape(__t))+
'">\n		';
 if (errors && errors.team_name) { 
__p+='\n			<div class="error">'+
((__t=( errors.team_name[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n	</div>\n\n	<p>Note: Avatars or Team Names deemed offensive may result in you being banned from continuing to play</p>\n\n	<div class="form-group">\n		<label for="t_and_cs" class="checkbox-container"><input type="checkbox" id="t_and_cs" name="t_and_cs" class="js-t-and-cs" value="1" '+
((__t=( (t_and_cs == 1) ? 'checked' : '' ))==null?'':_.escape(__t))+
' >\n			<span class="checkmark"></span>\n			<span class="label-text">I accept the <a href="/help/terms-and-conditions" class="text-link" target="_blank">Terms and Conditions</a>*</span>\n		</label>\n		';
 if (errors && errors.t_and_cs) { 
__p+='\n			<div class="error">'+
((__t=( errors.t_and_cs[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n		';
 if (errors && errors.server_side) { 
__p+='\n			<div class="error">'+
((__t=( errors.server_side[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n	</div>\n	<div class="buttons-wrapper">\n		<button type="button" class="btn secondary-btn js-back">Back</button>\n		<button type="submit" class="btn primary-btn js-next">Play now</button>\n	</div>\n</form>';
}
return __p;
};
